import React, {useEffect, useRef, useState} from 'react';
import {IonDatetime, IonItem, IonLabel, IonPopover, IonText} from "@ionic/react";
import {DateTime} from "luxon";
import {InputProps} from "components/forms/Input";
import pick from "lodash/pick";
import {usePrevious} from "../lib/hooks";
import styles from "./DateInput.module.css";

interface DateInputProps extends InputProps {
  presentation?: "date" | "date-time" | "month" | "month-year" | "time" | "time-date" | "year";
}

const DateInput: React.FC<DateInputProps> = (props) => {
  const {definition, state, disabled} = props;
  const presentation = props.presentation || 'date';
  const [isOpen, setIsOpen] = useState(false);
  const wasOpen = usePrevious(isOpen);
  const popRef = useRef<any>(null);

  const onResize = () => {
    // console.log('==> resizePop');
    const innerHeight = window.innerHeight;
    const pop = popRef.current;
    if (pop) {
      const height = pop.offsetHeight;
      let nTop = (innerHeight - height) / 2;
      if (nTop < 0)
        nTop = 0
      pop.style.top = `${nTop}px`;
    }
  };

  // resize listener
  useEffect(() => {
    if (!wasOpen && isOpen)
      window.addEventListener('resize', onResize);

    if (wasOpen && !isOpen)
      window.removeEventListener('resize', onResize);
  }, [isOpen, wasOpen]);

  const onChange = (e: any) => {
    if (e)
      props.onChange(definition.name, e.detail);
    else
      props.onChange(definition.name, undefined);
  };

  const iprops: any = {};
  Object.assign(iprops, pick(props,
    ['min', 'max']));

  return (
    <>
      <IonItem
        disabled={disabled}
        button
        onClick={() => setIsOpen(true)}
      >
        <IonLabel>
          <span className={(state.touched && state.hasError) ? "text-red-600" : ""}>
            {props.definition.label} {definition.required && '*'}
          </span>
        </IonLabel>
        <IonText slot="end">{state.value ?
          DateTime.fromISO(state.value).toFormat('dd/MM/yyyy') : ''}</IonText>
      </IonItem>

      <IonPopover
        isOpen={isOpen}
        onDidDismiss={() => setIsOpen(false)}
        showBackdrop={true}
        mode="md"
        className={styles.popOver}
        onDidPresent={e => {
          const t: any = e.currentTarget;
          if (t) {
            const q = t.getElementsByClassName('popover-content');
            if (q)
              popRef.current = q[0];
          }
        }}
      >
        <IonDatetime
          {...iprops}
          value={state.value}
          onIonChange={onChange}
          presentation={presentation}
          size="cover"
          showDefaultButtons
          cancelText="Cancelar"
          doneText="Confirmar"
        />
      </IonPopover>
    </>
  );
}

export default DateInput;
